module.exports = "<div class=\"layout-column layout-align-center-center\"><dynamic-image [alt]=\"alt\" [width]=\"width\" [image]=\"userImage\" text=\"{{name}}\"> </dynamic-image></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/user-image/user-image.component.pug
// module id = 639
// module chunks = 0